export const FeaturesAccessKeys = {
    paging: "getFeaturesAccessPaging",
    delete: "deleteFeatureAccess",
    get: "getFeatureAccess",
    update: "updateFeatureAccess",
    create: "createFeatureAccess"
}

export const formatOptions = (list: string[]) => {
    return list.map(it => ({ id: it }))
}

export const FeatureAccessNames = formatOptions(['disabled', 'hidden', 'mode', 'showInMoreMenu'])
export const BooleanAttributes = formatOptions(['true', 'false'])
export const FormModeAttributes = formatOptions(['edit', 'view', 'add'])


export const getAttributesByFeatureAccess = (name: string) => {
    switch (name) {
        case 'mode':
            return FormModeAttributes
        case 'disabled':
        case 'hidden':
        case 'showInMoreMenu':
            return BooleanAttributes
        default:
            return [];
    }
}
